function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouchbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 314 314"
    },
    viewBox: "0 0 314 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M259.8 183.2c.4 9.4-6.3 17.6-15.6 19-17.7 3.1-55 5-86.2 5s-68.4-1.9-86.2-5c-9.3-1.4-16-9.6-15.6-19v-59.1c.1-9.2 6.6-17.1 15.6-19 9-1.2 18.1-1.8 27.1-1.8 3.7.1 6.6 3.1 6.6 6.8V151.8c18.3 0 34.3-1.1 52.6-1.1s34.3 1 52.6 1.1v-41.3c-.3-3.7 2.5-6.9 6.2-7.2h.4c9 0 18.1.6 27 1.8 9 1.9 15.4 9.8 15.6 19l-.1 59.1zM158.1 2.8C73.1 2.2 3.8 70.7 3.3 155.6s67.9 154.3 152.9 154.8S310.5 242.5 311 157.5v-1C311.3 71.9 242.8 3 158.1 2.8z",
    style: {
      fillrule: "evenodd",
      cliprule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouchbase);
export default __webpack_public_path__ + "static/media/couchbase.5a2a4b5394888a21d480bfc62602d912.svg";
export { ForwardRef as ReactComponent };